import React, { FC } from "react";

import {
  useApisMembersKaizenIdeaRepliesLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  kaizenIdeaReplyId: string;
  onClose: () => void;
};

export const KaizenIdeaRepliesLikedEmployeesModal: FC<PropsType> = ({
  kaizenIdeaReplyId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersKaizenIdeaRepliesLikedEmployeesIndex({
      kaizenIdeaReplyId,
      config: {
        onSuccess: (data) => {
          setItems(data.pages.map((page) => page.kaizenIdeaReplyLikes).flat());
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
